import React from "react";
import I18n from "../../../i18n";
import { Metrics } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { isFunction } from "../../../util";
import { GraphDataMaker } from "../../../util/helper/graph";
import { getSplitRatio } from "./index";

export default ({
	header = "",
	onHeaderClick,
	chart_id, 
	data, previousData,
	height, 
	chartHeight,
	colorType,
	style, 
	showLegend = true, 
	showColor = true,
	showValue = true,
	isVertical = false, 
	short = false,
	onClick,
	onLegendClick
})=>{
	const mutateOnClick = isFunction(onClick) ? (select)=>{onClick(select.item);} : undefined;
	const mutateOnLegendClick = isFunction(onLegendClick) ? (select)=>{onLegendClick(select.item);} : mutateOnClick;
	return (<GraphCard 
		style={{...style, marginTop:Metrics.button.spaceMargin}} 
		header={header}
		onHeaderClick={onHeaderClick}
		height={height}
		isVertical = {isVertical}
		chartWidthRatio={getSplitRatio(short)}
		fullLegendOnVertical={false}
		graph={
			<Chart.PieChart 
				labelKey='item'
				valueKey='count'
				data={data} 
				height={chartHeight || height}
				visualColorKey={colorType}
				onClick={mutateOnClick}
			/>
		}
		legend={showLegend ? 
			<DataPercentList 
				percentDatas={data}
				compareDatas={previousData}
				textKey='item' valueKey='count'
				percentKey='percent'
				visualColorKey={colorType}
				showColor={showColor}
				showValue={showValue}
				onClick={mutateOnLegendClick}
			/> : undefined
		}
	/>
	);};


// WEBPACK FOOTER //
// ./src/components/report/generics/ReportPieChart.js